import { ChevronLeft } from '@material-ui/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import logo from '../../../../../../public/images/logo_aa.png';
import SmallPolygon from '../../../../../../static/smaller_polygon.png';
import MenuButton from '../MenuButton';
import { AngloAmericanLogo, BackButton, BiggerPolygonVector, FilterInputs, HeaderContainer, HorizontalContainer, SmallerPolygonVector, SubTitle, TextsContainer, Title, TitleContainer } from './styles';

interface IHeaderProps {
  title: string;
  showVectors?: boolean;
  showMenuToggle?: boolean;
  filterInputs?: React.ReactNode;
}

const Header: React.FC<IHeaderProps> = ({ title, filterInputs, showVectors = false, showMenuToggle }) => {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <HeaderContainer>
      <TitleContainer>
        <BackButton type="button" onClick={() => history.goBack()}>
          <ChevronLeft />
        </BackButton>

        <TextsContainer>
          <SubTitle>{t("menu.systemManagementBusinessUnits.link.parent")}</SubTitle>
          
          <HorizontalContainer>
            <Title>{title}</Title>

            {showMenuToggle && (
              <MenuButton />
            )}
          </HorizontalContainer>
        </TextsContainer>
      </TitleContainer>

      {filterInputs && (
        <FilterInputs>
          {filterInputs}  
        </FilterInputs>
      )}      
    
      {showVectors && (
        <>
          <SmallerPolygonVector src={SmallPolygon} alt="polygon-vector" />
          <BiggerPolygonVector src={SmallPolygon} alt="polygon-vector" />
        </>
      )}

      <AngloAmericanLogo onClick={() => history.push('/system-management/business')} src={logo} alt="polygon-vector" />
    </HeaderContainer>
  );
};

export default Header;
